import { useState } from "react";
import { requestGetServerTime } from "services/general";

const useAskTeacherTakeAttendance = ({
	loadingRequest,
	// studentReservations,
	// dialogNotifyNotCheckedOutTimeToStudentAttendance,
	dialogCheckInTimeQuestion,
	// dialogCheckOutTimeQuestion,
}) => {
	const [serverTime, setServerTime] = useState("-");
	async function askTakeAttendance(dialogCheckTimeQuestion) {
		loadingRequest.show();
		const serverTime = await requestGetServerTime();
		setServerTime(serverTime);
		loadingRequest.hide();
		dialogCheckTimeQuestion.set(true);
	}
	const askCheckInAttendance = () => {
		askTakeAttendance(dialogCheckInTimeQuestion);
	};
	// const askCheckOutAttendance = () => {
	// 	if (studentReservations.someStudentsHaveAttendance()) {
	// 		askTakeAttendance(dialogCheckOutTimeQuestion);
	// 		return;
	// 	}
	// 	dialogNotifyNotCheckedOutTimeToStudentAttendance.set(true);
	// };
	return {
		askCheckInAttendance,
		// askCheckOutAttendance,
		serverTime,
	};
};

export default useAskTeacherTakeAttendance;
